import { LINKEDIN_URL } from "../data/portfolio";
import LinkedInIcon from "./LinkedInIcon";

const ContactSection = () => (
  <section className="section-enter max-w-[1180px]">
    <div className="mb-2 flex items-baseline gap-4">
      <h2 className="font-heading text-[40px] font-medium tracking-[-0.02em]">
        Radio check
      </h2>
      <span className="text-[10.5px] uppercase tracking-kicker text-accent-300">
        Box, box
      </span>
    </div>

    <p className="mb-7 max-w-[620px] text-[14.5px] text-neutral-500">
      Hiring for a senior backend seat, or want a second opinion on an
      architecture call? Open channel.
    </p>

    <div className="grid max-w-[820px] grid-cols-2 gap-3.5">
      <a
        href={LINKEDIN_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="card flex flex-col gap-2.5 p-[22px]"
      >
        <LinkedInIcon size={20} className="text-accent" />
        <span className="font-heading text-[17px] font-medium text-ink">LinkedIn</span>
        <span className="break-all text-[12.5px] text-neutral-500">
          mario-alberto-dominguez-castillo
        </span>
      </a>
    </div>

    <p className="mt-7 flex items-center gap-3 text-[11px] uppercase tracking-[0.16em] text-neutral-600">
      <span className="h-px w-[60px] bg-gradient-to-r from-accent to-transparent" />
      Based in Mexico · Remote-friendly · Open to learn
    </p>
  </section>
);

export default ContactSection;
